import { Tooltip } from "antd";
import exclamationIcon from "assets/svg/exclamation.svg";
import exclamationIconBig from "assets/svg/exclamationbig.svg";

const ErrorTooltip = ({
  title,
  isActionItem,
  isDate = true,
}: {
  title: any;
  isActionItem?: boolean;
  isDate?: boolean;
}) => {
  return (
    <Tooltip
      title={title}
      className={`c-pointer exclamation_error ${isDate ? "date_error" : ""} ${
        isActionItem ? "actionItem_error" : ""
      }`}
      color="white"
      placement="top"
      overlayClassName={`error-tooltip ${
        isActionItem ? "actionItem_error_tooltip" : "error_custom_tooltip"
      }`}
    >
      <img src={isActionItem ? exclamationIconBig : exclamationIcon} alt="" />
    </Tooltip>
  );
};

export default ErrorTooltip;
